import { useQuery } from "urql";

import {
  DeskCollectionFilter,
  GetDeskCollectionDashboardStatisticsDocument,
} from "../../../../graphql/generated.ts";

export const useDeskCollectionDasboardStatistics = ({
  filter,
}: {
  filter: DeskCollectionFilter;
}) => {
  const variables = { filter };
  return useQuery({
    query: GetDeskCollectionDashboardStatisticsDocument,
    variables,
  });
};
